// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2C0QI","inner":"Form_inner__1-1O1","range":"Form_range__37F7G","name":"Form_name__1IGa7","actions":"Form_actions__3sKPh"};